import { render, staticRenderFns } from "./Attivita.vue?vue&type=template&id=2a5d62f4&scoped=true&"
import script from "./Attivita.vue?vue&type=script&lang=js&"
export * from "./Attivita.vue?vue&type=script&lang=js&"
import style0 from "./Attivita.vue?vue&type=style&index=0&id=2a5d62f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d62f4",
  null
  
)

export default component.exports